export default [{
  path: "/",
  component: function (resolve) {
    require(['../App'], resolve)
  }, //顶
  children: [ //二级路由，对应App.vue
    {
      path: '',
      redirect: '/tolist' //地址为空时跳转list
    },
    {
      path: '/securitycode',
      name: 'SecurityCode',
      component: function (resolve) {
        require(['../page/securitycode/SecurityCode.vue'], resolve)
      }
    },
    {
      path: '/collegevideo',
      name: 'CollegeVideo',
      component: function (resolve) {
        require(['../page/collegevideo/CollegeVideo.vue'], resolve)
      }
    },
    {
      path: '/collegeaudio',
      name: 'CollegeAudio',
      component: function (resolve) {
        require(['../page/collegeaudio/CollegeAudio.vue'], resolve)
      }
    },
    {
      path: '/artical',
      name: 'Artical',
      component: function (resolve) {
        require(['../page/artical/Artical.vue'], resolve)
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: function (resolve) {
        require(['../page/register/Register.vue'], resolve)
      }
    },
    {
      path: '/forgetpassword',
      name: 'ForgetPassword',
      component: function (resolve) {
        require(['../page/forgetpassword/ForgetPassword.vue'], resolve)
      }
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      component: function (resolve) {
        require(['../page/aboutus/AboutUs.vue'], resolve)
      }
    },
    {
      path: '/secret',
      name: 'Secret',
      component: function (resolve) {
        require(['../page/secret/Secret.vue'], resolve)
      }
    },
    {
      path: '/service',
      name: 'Service',
      component: function (resolve) {
        require(['../page/secret/Service.vue'], resolve)
      }
    },
    {
      path: '/indexsecred',
      name: 'IndexSecred',
      component: function (resolve) {
        require(['../page/secret/IndexSecred.vue'], resolve)
      }
    },
  ]
}]



// WEBPACK FOOTER //
// ./src/router/router.js